import React, { useEffect, useState } from 'react';
export function Hero() {
  const [minutes, setMinutes] = useState(10);
  const [seconds, setSeconds] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(timer);
        } else {
          setMinutes(minutes - 1);
          setSeconds(59);
        }
      }
    }, 1000);
    return () => clearInterval(timer);
  }, [minutes, seconds]);
  return <section className="bg-gradient-to-b from-orange-50 to-white" data-id="element-122">
      {/* Countdown Banner - Visible on all devices */}
      <div className="bg-orange-800 text-white py-2 px-4 flex items-center justify-center text-center sticky top-0 z-10" data-id="element-123">
        <span className="inline-block mr-2" data-id="element-124">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" data-id="element-125">
            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" data-id="element-126" />
          </svg>
        </span>
        <span className="font-bold" data-id="element-127">¡Oferta por tiempo limitado!</span>
        <span className="ml-2 bg-orange-600 px-2 py-1 rounded font-mono" data-id="element-128">
          {minutes.toString().padStart(2, '0')}:
          {seconds.toString().padStart(2, '0')}
        </span>
      </div>
      <div className="container mx-auto px-4 py-8 md:py-16" data-id="element-129">
        {/* Mobile Layout (stacked) */}
        <div className="flex flex-col md:hidden items-center text-center" data-id="element-130">
          <h1 className="text-4xl font-bold text-orange-600 mb-3" data-id="element-131">
            ¿Quieres que tus hijos hablen inglés... sin perder el español?
          </h1>
          <div className="mb-4" data-id="element-132">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2mX5GStNAfV117eqAGBEXD/1-_Guia_de_Crianza_Bilingue_%28Mockup%29.png" alt="Guía de Crianza Bilingüe" className="w-full max-w-sm mx-auto shadow-xl rounded-md" data-id="element-133" />
          </div>
          <p className="text-lg text-gray-600 mb-6 max-w-md" data-id="element-134">
            Un método probado para familias hispanas en EE.UU. que quieren criar
            hijos bilingües de forma natural, divertida y efectiva.
          </p>
          <div className="flex flex-col space-y-3 w-full max-w-xs" data-id="element-135">
            <a href="#comprar" className="bg-orange-600 text-white text-center px-6 py-3 rounded-md text-lg font-medium hover:bg-orange-700 transition-colors shadow-md" data-id="element-136">
              Descargar Ahora
            </a>
            <a href="#testimonios" className="bg-white text-orange-600 border border-orange-600 text-center px-6 py-3 rounded-md text-lg font-medium hover:bg-orange-50 transition-colors" data-id="element-137">
              Ver Testimonios
            </a>
          </div>
        </div>
        {/* Desktop Layout (side by side) */}
        <div className="hidden md:flex md:flex-row md:items-center md:py-12" data-id="element-138">
          <div className="md:w-1/2 md:pr-12" data-id="element-139">
            <h1 className="text-4xl md:text-5xl font-bold text-orange-600 mb-6" data-id="element-140">
              ¿Quieres que tus hijos hablen inglés... sin perder el español?
            </h1>
            <p className="text-lg text-gray-600 mb-8" data-id="element-141">
              Un método probado para familias hispanas en EE.UU. que quieren
              criar hijos bilingües de forma natural, divertida y efectiva.
            </p>
            <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4" data-id="element-142">
              <a href="#comprar" className="bg-orange-600 text-white text-center px-6 py-3 rounded-md text-lg font-medium hover:bg-orange-700 transition-colors shadow-md" data-id="element-143">
                Descargar Ahora
              </a>
              <a href="#testimonios" className="bg-white text-orange-600 border border-orange-600 text-center px-6 py-3 rounded-md text-lg font-medium hover:bg-orange-50 transition-colors" data-id="element-144">
                Ver Testimonios
              </a>
            </div>
          </div>
          <div className="md:w-1/2" data-id="element-145">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2mX5GStNAfV117eqAGBEXD/1-_Guia_de_Crianza_Bilingue_%28Mockup%29.png" alt="Guía de Crianza Bilingüe" className="w-full max-w-md mx-auto shadow-xl rounded-md transform hover:scale-105 transition-transform duration-300" data-id="element-146" />
          </div>
        </div>
      </div>
    </section>;
}